module.exports = __webpack_public_path__ + "img/strip-4.6d6f7883.svg";